import React, { useState } from 'react'

import useDidMountEffect from 'pages/parts/useDidMountEffect'
import { GET, httpOk } from 'helpers/api';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDate, formatMoney } from 'helpers/helpers';
import Sortable from 'components/Sortable';

function Directory({ showModal, setShowModal }) {
	const { t } = useTranslation()

	const [search, setSearch] = useState("")
	const [filterData, setFilterData] = useState({
		sort: '',
	})

	const [showRollsHistory, setShowRollsHistory] = useState(false)

	const [rolls, setRolls] = useState([])
	const [rollsHistory, setRollsHistory] = useState([])

	function toggleModal(bool) {
		if (showRollsHistory) {
			setShowRollsHistory(false)
			return;
		}
		setShowModal(bool)
	}

	async function getRollHistory(item) {
		const response = await GET(`/helper/rolls-history`, { ...filterData, product_id: item.product_id }, { loader: true })
		if (httpOk(response)) {
			setShowRollsHistory(true)
			setRollsHistory(response.data)
			setFilterData({ ...filterData, item: item })
		}
	}

	async function getRolls() {
		const response = await GET('/helper/rolls', filterData)
		if (httpOk(response)) {
			setRolls(response.data)
		}
	}

	useDidMountEffect(() => {
		if (showModal) {
			getRolls()
		}
	}, [showModal]);

	useDidMountEffect(() => {
		if (showRollsHistory) {
			getRollHistory(filterData.item)
		} else {
			getRolls();
		}
	}, [filterData.sort]);

	function getProductsList() {
		var arr = [...rolls]

		if (showRollsHistory) {
			arr = [...rollsHistory]
		}

		if (search) {
			arr = arr.filter(item =>
				item.name.toLowerCase().includes(search.toLowerCase())
			);
		}

		return arr;
	}

	return (
		<>
			<Modal show={showModal} animation={false} centered size="lg"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>

					<Modal.Title>
						{showRollsHistory &&
							<i className="uil-angle-left-b cursor" onClick={() => setShowRollsHistory(false)}></i>
						}
						{t('directory')}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body >
					<div className="addition-wrapper no-scroll">
						<div className="mb-2">
							<label>{t('search')}</label>
							<input autoFocus type="text" className="form-control" value={search}
								onChange={(e) => setSearch(e.target.value)} />
						</div>

						<div>
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										<Sortable sortKey="name" filterData={filterData} setFilterData={setFilterData}>
											{t('name2')}
										</Sortable>
										<Sortable sortKey="wholesale_price" filterData={filterData} setFilterData={setFilterData} className="text-end" position="end">
											{t('wholesale_price')}
										</Sortable>
										<Sortable sortKey="created_at" filterData={filterData} setFilterData={setFilterData} className="text-center">
											{t('date')}
										</Sortable>
									</tr>
								</thead>
								<tbody>
									{getProductsList().map((item, index) => (
										<tr key={index} className="cursor" onClick={() => getRollHistory(item)}>
											<td>{item.name}</td>
											<td className="text-end">{formatMoney(item.wholesale_price, 2)}</td>
											<td className="text-center">{formatDate(item.created_at)}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
			</Modal>

		</>
	)
}

export default Directory